<!-- AI Generated Template -->
<div class="d-flex" [ngClass]="{ 'mb-3': tabsCount() == 0 && showSearch}">
    <div class="mr-auto">
        <ul class="nav nav-tabs table-nav-tabs inner-t-smurf" role="menu">
            <li class="cursor-pointer"
                *ngFor="let option of options; trackBy: trackByKey"
                [attr.data-test]="'tab-' + (option.name | e2eAttributeEncoding)"
                [ngClass]="{'active': status == option.value}"
                (click)="callback(option.value)"
                (keyup.enter)="callback(option.value)"
                role="menuitem"
                tabindex="0"
            >
                <a>
                    <span class="inline-block" [ngClass]="{'inner-t-smurf': !option.faIcon}">
                        <span *ngIf="option.faIcon" [ngClass]="option.faIcon" class="icon mr-1"></span>
                        {{ option.name }}
                        <span *ngIf="option.tooltip"
                              [ngbTooltip]="option.tooltip"
                              [placement]="'bottom'"
                              class="fas fa-question-circle"></span>
                    </span>
                </a>
            </li>

            <li class="cursor-pointer dropdown-container"
                [attr.data-test]="'tab-dropdown-more'"
                ngbDropdown
                #moreMenu="ngbDropdown"
                [attr.id]="'tabs-dropdown'"
                *ngIf="moreOptions.length > 0"
                [ngClass]="{'dropdown-container-active': moreActive}"
                (keyup.enter)="moreMenu.open()"
                role="menuitem"
                tabindex="0">
                <a ngbDropdownToggle>
                    <span class="fas font-size-1-5 fa-caret-down"></span>...
                </a>
                <ul class="dropdown-menu"
                    ngbDropdownMenu
                    role="menu"
                    [attr.aria-labelledby]="'tabs-dropdown'">
                    <li class="dropdown-item cursor-pointer"
                        *ngFor="let option of moreOptions; trackBy: trackByKey"
                        [ngClass]="{'active': status == option.value}"
                        (keyup.enter)="callback(option.value)"
                        role="menuitem"
                        tabindex="0"
                        (click)="callback(option.value)">
                            <span *ngIf="option.faIcon" [ngClass]="option.faIcon" class="icon mr-1"></span>{{ option.name }}
                    </li>
                </ul>
            </li>
        </ul>
    </div>
    <div class="hidden-xs hidden-sm d-none d-lg-block tab-right-section">
        <div class="d-flex align-items-center justify-content-end">
            <ng-content></ng-content>
            <filter-button
                [showFiltersBtn]="showFiltersBtn"
                [(isFiltersOpen)]="isFiltersOpen"
                (isFiltersOpenChange)="isFiltersOpenChange.emit($event)"
            >
            </filter-button>
            <table-search
                class="flex-grow-1"
                *ngIf="showSearch"
                (getPage)="changeSearch($event)"
                [model]="search"
                [minSearchLength]="minSearchLength.toString()">
            </table-search>
        </div>
    </div>
</div>
